"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "FormGroup", {
    enumerable: true,
    get: function() {
        return FormGroup;
    }
});
const _style = /*#__PURE__*/ _interop_require_default(require("styled-jsx/style"));
const _react = /*#__PURE__*/ _interop_require_default(require("react"));
const _FormGroupContext = require("../../../contexts/FormGroupContext");
const _FormHint = require("../FormHint/FormHint");
const _FormLabel = require("../FormLabel/FormLabel");
const _useHtmlId = require("../../../hooks/useHtmlId");
const _Theme = require("../../../contexts/Theme");
const _adminicons = require("../../../admin-icons");
const _endusericons = require("../../../end-user-icons");
const _Tooltip = require("../../Tooltip/Tooltip");
function _interop_require_default(obj) {
    return obj && obj.__esModule ? obj : {
        default: obj
    };
}
const FormGroup = (param)=>{
    let { label, error, required = false, hint, id: inputId, children, hasError = error != null && error !== "", showTooltip = false, tooltipText, tooltipPlacement = "right", inline = false, noHeaderMargin = false, labelWidth, noGroupMargin, ...props } = param;
    const { isAdmin, spacers, breakpoints } = (0, _Theme.useTheme)();
    const id = (0, _useHtmlId.useHtmlId)(inputId);
    const labelId = "".concat(id, "-label");
    const hintId = "".concat(id, "-hint");
    const TooltipIcon = isAdmin ? _adminicons.RiInformationLine : _endusericons.BsInfoCircle;
    const { styles: inlineResponsiveStyles, className } = typeof inline !== "string" ? {
        styles: /*#__PURE__*/ _react.default.createElement(_style.default, {
            id: "b3e1b6a7c9b96113"
        }, ""),
        className: "jsx-b3e1b6a7c9b96113"
    } : {
        styles: /*#__PURE__*/ _react.default.createElement(_style.default, {
            id: "fcce2a21a5d6df8a",
            dynamic: [
                breakpoints[inline]
            ]
        }, "@media screen (max-width: ".concat(breakpoints[inline], "px) {.form-group.__jsx-style-dynamic-selector{display:block}.tooltip.__jsx-style-dynamic-selector{margin-top:3px}.form-header.__jsx-style-dynamic-selector{width:auto}}")),
        className: _style.default.dynamic([
            [
                "fcce2a21a5d6df8a",
                [
                    breakpoints[inline]
                ]
            ]
        ])
    };
    var _props_className;
    return /*#__PURE__*/ _react.default.createElement("div", {
        ...props,
        role: "group",
        className: _style.default.dynamic([
            [
                "9c5088f0bc866b8c",
                [
                    isAdmin && noGroupMargin !== true ? spacers.s6 : spacers.s0,
                    inline !== false ? "flex" : "block",
                    spacers.s2,
                    inline !== false ? "11px" : "3px",
                    isAdmin ? "uppercase" : undefined,
                    inline !== false ? labelWidth !== null && labelWidth !== void 0 ? labelWidth : "40%" : undefined
                ]
            ]
        ]) + " " + "form-group ".concat((_props_className = props.className) !== null && _props_className !== void 0 ? _props_className : "", " ").concat(className)
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "9c5088f0bc866b8c",
                [
                    isAdmin && noGroupMargin !== true ? spacers.s6 : spacers.s0,
                    inline !== false ? "flex" : "block",
                    spacers.s2,
                    inline !== false ? "11px" : "3px",
                    isAdmin ? "uppercase" : undefined,
                    inline !== false ? labelWidth !== null && labelWidth !== void 0 ? labelWidth : "40%" : undefined
                ]
            ]
        ]) + " " + "form-header"
    }, label != null || required ? /*#__PURE__*/ _react.default.createElement(_FormLabel.FormLabel, {
        noMargin: noHeaderMargin,
        required: required,
        htmlFor: id,
        id: labelId,
        inline: inline
    }, label) : null, showTooltip && /*#__PURE__*/ _react.default.createElement(_Tooltip.Tooltip, {
        title: tooltipText !== null && tooltipText !== void 0 ? tooltipText : "",
        placement: tooltipPlacement,
        showArrow: true,
        limitMobileWidth: true
    }, /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "9c5088f0bc866b8c",
                [
                    isAdmin && noGroupMargin !== true ? spacers.s6 : spacers.s0,
                    inline !== false ? "flex" : "block",
                    spacers.s2,
                    inline !== false ? "11px" : "3px",
                    isAdmin ? "uppercase" : undefined,
                    inline !== false ? labelWidth !== null && labelWidth !== void 0 ? labelWidth : "40%" : undefined
                ]
            ]
        ]) + " " + "tooltip"
    }, /*#__PURE__*/ _react.default.createElement(TooltipIcon, {
        color: "#666666",
        className: _style.default.dynamic([
            [
                "9c5088f0bc866b8c",
                [
                    isAdmin && noGroupMargin !== true ? spacers.s6 : spacers.s0,
                    inline !== false ? "flex" : "block",
                    spacers.s2,
                    inline !== false ? "11px" : "3px",
                    isAdmin ? "uppercase" : undefined,
                    inline !== false ? labelWidth !== null && labelWidth !== void 0 ? labelWidth : "40%" : undefined
                ]
            ]
        ])
    })))), /*#__PURE__*/ _react.default.createElement("div", {
        className: _style.default.dynamic([
            [
                "9c5088f0bc866b8c",
                [
                    isAdmin && noGroupMargin !== true ? spacers.s6 : spacers.s0,
                    inline !== false ? "flex" : "block",
                    spacers.s2,
                    inline !== false ? "11px" : "3px",
                    isAdmin ? "uppercase" : undefined,
                    inline !== false ? labelWidth !== null && labelWidth !== void 0 ? labelWidth : "40%" : undefined
                ]
            ]
        ])
    }, /*#__PURE__*/ _react.default.createElement(_FormGroupContext.FormGroupContext.Provider, {
        value: {
            label,
            labelId,
            hintId,
            error,
            required,
            hint,
            id,
            hasError
        }
    }, children), /*#__PURE__*/ _react.default.createElement(_FormHint.FormHint, {
        hint: hint,
        error: error,
        id: hintId
    })), /*#__PURE__*/ _react.default.createElement(_style.default, {
        id: "9c5088f0bc866b8c",
        dynamic: [
            isAdmin && noGroupMargin !== true ? spacers.s6 : spacers.s0,
            inline !== false ? "flex" : "block",
            spacers.s2,
            inline !== false ? "11px" : "3px",
            isAdmin ? "uppercase" : undefined,
            inline !== false ? labelWidth !== null && labelWidth !== void 0 ? labelWidth : "40%" : undefined
        ]
    }, "div.__jsx-style-dynamic-selector{width:100%}.form-group.__jsx-style-dynamic-selector{margin-bottom:".concat(isAdmin && noGroupMargin !== true ? spacers.s6 : spacers.s0, ";display:").concat(inline !== false ? "flex" : "block", "}.tooltip.__jsx-style-dynamic-selector{margin-left:").concat(spacers.s2, ";opacity:1;position:relative;z-index:1;height:1rem;margin-top:").concat(inline !== false ? "11px" : "3px", ";width:-webkit-max-content;width:-moz-max-content;width:max-content}.tooltip.__jsx-style-dynamic-selector svg.__jsx-style-dynamic-selector{display:block}.tooltip-text .multi-line{text-align:left!important}.form-header.__jsx-style-dynamic-selector{display:-webkit-box;display:-webkit-flex;display:-moz-box;display:-ms-flexbox;display:flex;-webkit-box-orient:horizontal;-webkit-box-direction:normal;-webkit-flex-direction:row;-moz-box-orient:horizontal;-moz-box-direction:normal;-ms-flex-direction:row;flex-direction:row;text-transform:").concat(isAdmin ? "uppercase" : undefined, ";width:").concat(inline !== false ? labelWidth !== null && labelWidth !== void 0 ? labelWidth : "40%" : undefined, "}")), inlineResponsiveStyles);
};

//# sourceMappingURL=FormGroup.js.map